{
  "locales": [
    "ko", "en", "ja", "id", "th", "fil", "vi", "ms", "uz", "fr",
    "km", "ru", "zh-CN", "zh-TW", "es", "pt", "de", "it", "tr",
    "en-SG", "pt-BR", "nl", "pl", "hi-IN", "bn-IN", "te-IN", "pa-IN", "ml-IN", "ta-IN",
    "et", "zh-HK"
  ]
}
